import { Button, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as CopyLinkIcon } from 'assets/icons/share_link.svg';
import { useTranslation } from 'react-i18next';

type LinkSharingProps = {
  disabled?: boolean;
  onCopyLink: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
};

export const LinkSharing = ({ disabled = false, onCopyLink }: LinkSharingProps) => {
  const { t } = useTranslation('common_navbar');

  if (disabled) return null;

  const linkSharingTestId = 'link-sharing';
  const linkSharingCopyLinkButtonTestId = 'link-sharing-copy-link-button';

  return (
    <Flex flexDir='column' gap='2' data-testid={linkSharingTestId}>
      <Flex flexDir='column'>
        <Text fontWeight='semibold' fontSize='sm' lineHeight='1.25' color={'font.500'}>
          {t('modals.share-panel.link-sharing.title')}
        </Text>
        <Flex flexDir='row' justifyContent='space-between' alignItems='center' my='2'>
          <Flex direction={'column'} color='font.300'>
            <Text fontSize='xs' lineHeight='1.43'>
              {t('modals.share-panel.link-sharing.message1')}
            </Text>
            <Text fontSize='xs' lineHeight='1.43'>
              {t('modals.share-panel.link-sharing.message2')}
            </Text>
          </Flex>
          <Button
            onClick={onCopyLink}
            variant='action'
            size='sm'
            width='28'
            leftIcon={<CopyLinkIcon style={{ marginRight: 1 }} />}
            data-testid={linkSharingCopyLinkButtonTestId}
          >
            {t('modals.share-panel.copy-link')}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
